export var c_background_image_BackgroundImage = {
  "name": "--pf-c-background-image--BackgroundImage",
  "value": "url(\"../../assets/images/pfbg_576.jpg\")",
  "var": "var(--pf-c-background-image--BackgroundImage)"
};
export default c_background_image_BackgroundImage;